import { ChevronRight } from "lucide-react"

interface Props {
  onClick: () => void
  disabled: boolean
}

const NextBtn = ({ onClick, disabled }: Props) => (
  <button
    aria-label="Next"
    type="button"
    onClick={onClick}
    disabled={disabled}
    className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50 hover:text-base-dark"
  >
    <span className="sr-only">Next</span>
    <ChevronRight size={16} aria-hidden="true" />
  </button>
)

export default NextBtn
